import React, { FC } from 'react';
import { RightOutline } from 'antd-mobile-icons';
import styles from './index.less';

interface ComProps {
  style?: React.CSSProperties;
}

const VideoMatch: FC<ComProps> = ({
  style,
}) => {
  // 跳转微视频大赛-征集令
  const handleGoToVideoMatch = () => {
    window.open('http://competition.gjwlaqxcz.cn/app/home');
  }

  return (
    <div className={styles.comWrapper} style={style}>
      <div className={styles.matchVideo}>
        <div className={styles.viewMore} onClick={handleGoToVideoMatch}>查看更多<RightOutline /></div>
      </div>
      <div className={styles.matchVideoCover} onClick={handleGoToVideoMatch}>
        <img src="https://s.newscdn.cn/file/2022/08/01ce61dd-6ffb-47de-8df4-0b3d9325dfbb.png" alt="" />
      </div>
    </div>
  );
};

export default VideoMatch;
